import { ImageAtoms } from '@vfit/shared/atoms';
import { useEffect, useState } from 'react';
import { purify } from '@vfit/shared/themes';
import { VfModal } from '@vfit/shared/components';
import { trackLink } from '@vfit/shared/data-access';
import * as S from './addonCardOffer.style';
import { IAddonCardOfferProps } from './addonCardOffer.models';
import { ModalContent } from './components/modalContent';
import ButtonCBU from '../ButtonCBU/buttonCBU';

const AddonCardOffer = ({
  title,
  price,
  subprice,
  imageUri,
  ctaAddLabel,
  ctaRemoveLabel,
  closePopupLabel,
  description,
  ctaOpenDetailsLabel,
  popupBody,
  addonId,
  popupTitle,
  added = false,
  isLoadingUpdate,
  isLoadingCartUpdate,
  noPriceLabel,
  loadingId,
  saveAddon,
  removeAddon,
}: IAddonCardOfferProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [ptitle, pDescription, pNoPriceLabel, pSubprice] = purify([
    title,
    description,
    noPriceLabel,
    subprice,
  ]);

  const isLoading = isLoadingUpdate || isLoadingCartUpdate;

  const handleAddAction = (_addonId: string) => {
    if (isOpenModal) setIsOpenModal(false);
    saveAddon(_addonId);
  };

  const handleRemoveAction = (_addonId: string) => {
    if (isOpenModal) setIsOpenModal(false);
    removeAddon(_addonId);
  };

  const handleClosePopup = (label: string) => {
    trackLink(label || 'chiudi', 'users', 'click', 'ui_interaction');
    setIsOpenModal(false);
  };

  const handleOpenDetails = () => {
    trackLink(ctaOpenDetailsLabel);
    setIsOpenModal(true);
  };

  return (
    <>
      <S.CardContainer>
        {imageUri && (
          <S.ImageContainer>
            <ImageAtoms
              image={imageUri}
              imageMobile={imageUri}
              style={{ borderRadius: '16px 16px 0 0' }}
              nameCard="addon-image"
            />
          </S.ImageContainer>
        )}
        <S.BodyContainer>
          <S.TitleGroup>
            <S.Title dangerouslySetInnerHTML={{ __html: ptitle || '' }} />
            {price !== '' && <S.Price>{price}</S.Price>}
            {price === '' && pNoPriceLabel && pNoPriceLabel !== '' && (
              <S.NoPriceLabel dangerouslySetInnerHTML={{ __html: pNoPriceLabel }} />
            )}
            <S.Subprice dangerouslySetInnerHTML={{ __html: pSubprice || '' }} />
          </S.TitleGroup>
          <S.CtaContainer>
            <ButtonCBU
              onClick={() => (added ? handleRemoveAction(addonId) : handleAddAction(addonId))}
              variant={added ? 'secondary' : 'primary'}
              loading={isLoading && loadingId === addonId}
              disabled={isLoading && loadingId !== addonId}
              key={addonId + (added ? '_remove' : '_add')}
            >
              {added ? ctaRemoveLabel : ctaAddLabel}
            </ButtonCBU>
          </S.CtaContainer>

          <S.Description dangerouslySetInnerHTML={{ __html: pDescription || '' }} />
          <S.DetailsCta onClick={handleOpenDetails}>{ctaOpenDetailsLabel}</S.DetailsCta>
        </S.BodyContainer>
      </S.CardContainer>
      <VfModal isOpen={isOpenModal} handleClose={() => handleClosePopup('x')}>
        <ModalContent
          added={added}
          addonId={addonId}
          popupTitle={popupTitle}
          ctaRemoveLabel={ctaRemoveLabel}
          ctaAddLabel={ctaAddLabel}
          closePopupLabel={closePopupLabel}
          handleRemoveAction={handleRemoveAction}
          handleAddAction={handleAddAction}
          handleClosePopup={handleClosePopup}
          popupBody={popupBody}
          isPerformingAction={isLoading}
          loadingId={loadingId}
        />
      </VfModal>
    </>
  );
};

export default AddonCardOffer;

